module.exports = " <main class=c-main> <article class=\"markdown-body c-markdown-body u-gutter\" v-html=docsMarkdownExample></article> <app-footer></app-footer> </main> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src-docs/app/pages/DocsMarkdownExamplePage.vue
// module id = 83
// module chunks = 1